/**
 * Converts the `maxEmployees` value to a numeric format.
 * If `maxEmployees` is an empty string, it will return `Number.POSITIVE_INFINITY`,
 * otherwise, it converts `maxEmployees` to a number.
 *
 * @param maxEmployees - The maximum number of employees in string format. If empty, it represents an unlimited number of employees.
 * @returns The `maxEmployees` value in numeric format, or `Number.POSITIVE_INFINITY` if `maxEmployees` is an empty string.
 */
export const maxEmployeesToNumeric = (maxEmployees?: number): number | undefined => {
  if (maxEmployees === undefined) return undefined;

  return maxEmployees === 0 ? Number.POSITIVE_INFINITY : Number(maxEmployees);
};

/**
 * Converts the `minEmployees` value to a numeric format.
 * If `minEmployees` is an empty string, it will return `0`,
 * otherwise, it converts `minEmployees` to a number.
 *
 * @param minEmployees - The minimum number of employees in string format. If empty, it represents zero employees.
 * @returns The `minEmployees` value in numeric format, or `0` if `minEmployees` is an empty string.
 */
export const minEmployeesToNumeric = (minEmployees?: number): number | undefined => {
  if (minEmployees === undefined) return undefined;

  return minEmployees === 0 ? 0 : Number(minEmployees);
};
